import React, { Fragment, useEffect } from "react";

import { AppProvider, useAppContext } from "./helpers/account-context";
import { getMapGeo, storeMapGeo, getParameters, getUsingMap, setUsingMap } from "./helpers/sharedUtils";
import { fetchAccount, fetchGeoIp, CBAnalytics, fetchRegions } from "./helpers/apiEndpoints";

import MapApp from "./MapApp";
import MapBox from "./MapBox";
import OpenMap from "./OpenMap";

const cleanDefaultParams = () => {

  const {preview, search, location} = getParameters()
  const params = {}
  if (preview === "1") {
    params.preview = true;
  }
  if (location && location.length > 1) {
    params.location = location;
  }
  if (search && search.length > 1) {
    params.search = search;
  }

  return {...params}
}


const MapWidget = (props) => {

  const {
    setInitedData, 
    setCurrentGeo, 
    account,
    setAccount,
    setRegions
  } = useAppContext();
  const initedData = {
    ...props, ...cleanDefaultParams() 
  }

  let cachedGeo = getMapGeo();

  const accountId = props.accountId;

  const requestBrowserGeo = () => {
    if (!initedData.geolocation) return false;
    if (!navigator.geolocation) return false;
    if(cachedGeo && !!cachedGeo.address && !cachedGeo.ip) return true;

    navigator.geolocation.getCurrentPosition((position) => {
      const { coords = {} } = position;
      const coordData = {
        lat: coords.latitude,
        lng: coords.longitude,
        ip: 0,
        expiredAt: Date.now() + 7 * 24 * 60 * 60 * 1000,
      };
      setCurrentGeo({ ...coordData });
      storeMapGeo({ ...coordData });
    });
  };

  const requestGeoIp = async () => {
    if (!initedData.geolocation) return false;

    if (cachedGeo.lat) return true;

    fetchGeoIp(accountId).then(({ resource: geoData }) => {
      if (geoData.location) {
        const coordData = {
          lat: geoData.location.latitude,
          lng: geoData.location.longitude,
          address: [geoData.city?.names.en, geoData.country?.names.en]
            .filter((x) => !!x)
            .join(" "),
          ip: 1,
          expiredAt: Date.now() + 1 * 24 * 60 * 60 * 1000,
        };
        setCurrentGeo({ ...coordData });
        storeMapGeo({ ...coordData });
      }
    });
  };

  const requestAccountInfo = async () => {
    fetchAccount(accountId, null, initedData.preview).then(({ resource }) => {
      setAccount(resource);
      if (resource.map_options) {
        setInitedData({...resource.map_options, ...initedData})
      }
    });
    if (!initedData.preview) {
      CBAnalytics.view(accountId, {
        url: window.location.href,
      });
    }
  };
  
  const requestAccountRegions = async () => {
    fetchRegions(accountId, null, initedData.preview).then(({ resources }) => {
      if (resources) {
        setRegions(resources);
      }
    });
  };
  
  useEffect(() => {
    setCurrentGeo({...cachedGeo})
    setInitedData({...props, ...cleanDefaultParams() })
    requestBrowserGeo();
    requestGeoIp();
    requestAccountInfo();
    requestAccountRegions();
  }, []);

  if (!account) return <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>Loading...</div>;
  let mapType = getUsingMap();

  const availTypes = ['mapbox', 'gmaps'];
  if (!mapType) {
    mapType = availTypes[Math.round(Math.random()*1)];
  }
  // return <Fragment>
  //   <OpenMap/>
  //   <MapBox/>
  //   <MapApp/>
  //   </Fragment>
  if (account.force_map_provider === 'osm') {
    return <OpenMap/>
  }
  
  if (account.mapbox_api_key && (account.force_map_provider === 'mapbox' || !account.gmap_api_key || mapType === 'mapbox')) {
    setUsingMap('mapbox');
    return <MapBox/>
  }

  if (account.gmap_api_key && (account.force_map_provider === 'gmaps' || !account.mapbox_api_key || mapType === 'gmaps')){
    setUsingMap('gmaps');
    return <MapApp/>
  }

  return <OpenMap/>
};

const CBMapWiget = (props) => {
  return <AppProvider>         
      <MapWidget
        {...props}
      />
    </AppProvider>
}
export default CBMapWiget;
